import { Link } from 'gatsby';
import styled from '../styled';

export const TopicBadge = styled<typeof Link, { variant: 'black' | 'blue' }>(
  Link
)`
  display: block;
  position: relative;
  top: -2px;
  font-size: 8px;
  line-height: 14px;
  padding: 4px 8px;
  background-color: ${(p) =>
    p.variant === 'black'
      ? p.theme.palette.grey[900]
      : p.theme.palette.primary.dark};
  border-radius: 4px;
  font-weight: 900;
  text-transform: uppercase;
  display: inline-block;
  margin-right: 8px;
  transform: scale(1);
  transition: transform 0.1s ease-in;

  &:hover {
    transform: scale(1.05);
    box-shadow: ${(p) =>
      p.variant === 'black'
        ? '0px 0px 10px rgb(11 53 92 0.5)'
        : '0px 0px 10px rgb(30 111 186 0.5)'};
  }
`;
